import {
	createSlice,
	current
} from '@reduxjs/toolkit';
import {
	getTransferTypeList,
	addNewTransferType,
	updateTransferType,
	deleteTransferType,
	getTransferType,
	existsTransferType,
	getTransferTypeListByCompany
} from '../transferType/thunk';

export const initialState = {
	itemTransferTypeList: [],
	itemTransferTypeDetail: null,
	isTransferTypeLoading: false,
	isTransferTypeSuccess: false,

	transferTypeList: [],
	transferTypeListSelect: [],
	isLoadingList: false,
	isAdding: false,
	isAdded: false,
	isAddError: false,
	isUpdating: false,
	isUpdated: false,
	isUpdateError: false,
	isDeleting: false,
	isDeleted: false,
	isDeleteError: false,
	requireCloseModal: false,
	exists: false,
};

const TransferTypeSlice = createSlice({
	name: 'TransferType',
	initialState,
	reducers: {
		setRequireCloseModal(state, action) {
			state.requireCloseModal = action.payload;
		},
	},
	extraReducers: builder => {
		builder.addCase(getTransferType.fulfilled, (state, action) => {
			state.isTransferTypeLoading = false;
			state.isTransferTypeSuccess = true;
			state.itemTransferTypeDetail = action.payload;
			state.isLoadingList = false;
		});
		builder.addCase(getTransferType.pending, state => {
			state.isTransferTypeLoading = true;
			state.isTransferTypeSuccess = null;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getTransferType.rejected, (state, action) => {
			state.isTransferTypeLoading = false;
			state.isTransferTypeSuccess = false;
			state.error = action.error.message;
			state.isLoadingList = false;
		});

		builder.addCase(getTransferTypeList.pending, state => {
			state.isTransferTypeSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getTransferTypeList.fulfilled, (state, action) => {
			state.itemTransferTypeList = action.payload;
			state.transferTypeList = action.payload;
			state.isLoadingList = false;
			state.isTransferTypeSuccess = true;

			let transferTypeListSelect = [];
			action.payload.map(item =>
				transferTypeListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.transferTypeListSelect = transferTypeListSelect;
		});
		builder.addCase(getTransferTypeList.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isTransferTypeSuccess = true;
		});
		

		builder.addCase(getTransferTypeListByCompany.pending, state => {
			state.isTransferTypeSuccess = true;
			state.error = null;
			state.isLoadingList = true;
		});
		builder.addCase(getTransferTypeListByCompany.fulfilled, (state, action) => {
			state.itemTransferTypeList = action.payload;
			state.transferTypeList = action.payload;
			state.isLoadingList = false;
			state.isTransferTypeSuccess = true;

			let transferTypeListSelect = [];
			action.payload.map(item =>
				transferTypeListSelect.push({
					item: item,
					value: item._id,
					label: item.name,
				})
			);

			state.transferTypeListSelect = transferTypeListSelect;
		});
		builder.addCase(getTransferTypeListByCompany.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isTransferTypeSuccess = true;
		});

		builder.addCase(addNewTransferType.fulfilled, (state, action) => {
			state.itemTransferTypeList.push(action.payload);
			state.transferTypeList.push(action.payload);
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = true;
			state.isAddError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(addNewTransferType.pending, (state, action) => {
			state.isLoadingList = true;
			state.isAdding = true;
			state.isAdded = false;
			state.isAddError = false;
		});
		builder.addCase(addNewTransferType.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isAdding = false;
			state.isAdded = false;
			state.isAddError = true;
		});

		builder.addCase(updateTransferType.fulfilled, (state, action) => {
			state.itemTransferTypeList = state.itemTransferTypeList.map(transferType =>
				transferType.transferTypename === action.payload.old_transferType
					? { ...transferType, ...action.payload.updated_transferType }
					: transferType
			);
			state.transferTypeList = state.transferTypeList.map(transferType =>
				transferType._id.toString() === action.payload._id.toString()
					? { ...transferType, ...action.payload }
					: transferType
			);
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = true;
			state.isUpdateError = false;
			state.requireCloseModal = true;
		});
		builder.addCase(updateTransferType.pending, state => {
			state.isLoadingList = true;
			state.isUpdating = true;
			state.isUpdated = false;
			state.isUpdateError = false;
		});
		builder.addCase(updateTransferType.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isUpdating = false;
			state.isUpdated = false;
			state.isUpdateError = true;
		});

		builder.addCase(deleteTransferType.fulfilled, (state, action) => {
			state.itemTransferTypeList = current(state.itemTransferTypeList).filter(
				item => item._id !== action.payload._id
			);
			state.transferTypeList = current(state.transferTypeList).filter(item =>
				item._id !== action.payload._id
			);
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
			state.requireCloseModal = true;
		});
		builder.addCase(deleteTransferType.pending, (state, action) => {
			state.isLoadingList = true;
			state.isDeleting = false;
			state.isDeleted = true;
			state.isDelete = false;
		});
		builder.addCase(deleteTransferType.rejected, (state, action) => {
			state.error = action.payload || null;
			state.isLoadingList = false;
			state.isDeleting = false;
			state.isDeleted = false;
			state.isDelete = true;
		}); 

		builder.addCase(existsTransferType.fulfilled, (state, action) => {
			state.exists = false;
			if (action.payload === true)
				state.exists = true;
		});
		builder.addCase(existsTransferType.pending, (state, action) => {
			state.exists = false;
		});
		builder.addCase(existsTransferType.rejected, (state, action) => {
			state.exists = false;
		});
	},
});

export const { setRequireCloseModal } = TransferTypeSlice.actions;

export default TransferTypeSlice.reducer;